import React, { useState } from 'react';
import { Alert, Typography } from '@mui/material';
import { IDayOffWork } from '../Interfaces/IDayOffWork';
import { IUser } from '../Interfaces/IUser';
import { IEmploymentContract } from '../Interfaces/IEmploymentContract';
import { IDayOffWorkCategory } from '../Interfaces/IDayOffWorkCategory';
import { DayOffWorkOverviewTable } from './DayOffWorkOverviewTable';
import { LoadingSpinner } from '../core/LoadingSpinner';
import {
  useGetDaysOffWork,
  useGetDaysOffWorkCategories,
} from '../hooks/reactQuerys/DaysOffWorkQueries';
import { useGetUsers } from '../hooks/reactQuerys/UserQueries';
import { useGetEmploymentContracts } from '../hooks/reactQuerys/EmploymentContractQueries';

type IProps = {
  initialDaysOffWork: IDayOffWork[];
  daysOffWorkCategories: IDayOffWorkCategory[];
  employmentContracts: IEmploymentContract[];
  users: IUser[];
};

export const DayOffWorkOverview = () => {
  const { daysOffWork, isLoadingDaysOffWork } = useGetDaysOffWork();
  const { daysOffWorkCategories, isLoadingDaysOffWorkCategories } =
    useGetDaysOffWorkCategories();
  const { employmentContracts, isLoadingEmploymentContracts } =
    useGetEmploymentContracts();
  const { users, isLoadingUsers } = useGetUsers();

  if (
    isLoadingDaysOffWork ||
    isLoadingDaysOffWorkCategories ||
    isLoadingEmploymentContracts ||
    isLoadingUsers
  ) {
    return <LoadingSpinner />;
  }

  if (
    !daysOffWork ||
    !daysOffWorkCategories ||
    !employmentContracts ||
    !users
  ) {
    return <Alert severity='error'>Fehler!</Alert>;
  }

  return (
    <DayOffWork
      initialDaysOffWork={daysOffWork}
      daysOffWorkCategories={daysOffWorkCategories}
      employmentContracts={employmentContracts}
      users={users}
    />
  );
};

export const DayOffWork = ({
  initialDaysOffWork,
  daysOffWorkCategories,
  employmentContracts,
  users,
}: IProps) => {
  const [daysOffWork, setDaysOffWork] =
    useState<IDayOffWork[]>(initialDaysOffWork);

  return (
    <>
      <Typography variant='h6'>Fehltage: Personalkalender</Typography>

      <DayOffWorkOverviewTable
        userArray={users}
        employmentContractArray={employmentContracts}
        dayOffWorkCategoryArray={daysOffWorkCategories}
        dayOffWorkArray={daysOffWork}
        setDayOffWorkArray={setDaysOffWork}
      />
    </>
  );
};
